import clsx from 'clsx'
import coinIcon from '../assets/coin-icon.png'

interface ChartItemProps {
  index?: number
  date?: string
  value?: string | number
  amount?: number
  barHeight?: number
  isLoading?: boolean
  isEmpty?: boolean
}

export function ChartItem({
  index,
  date,
  value,
  amount,
  barHeight,
  isLoading,
  isEmpty,
}: ChartItemProps) {
  const testId = isLoading ? `chart-skeleton-${index}` : `chart-item-${date}`

  return (
    <div className='flex flex-col items-center gap-[8px]' data-testid={testId}>
      {/* 顶部数值 */}
      <div className='flex flex-col items-center gap-[4px]'>
        {isLoading ? (
          <>
            <div className='size-[16px] animate-pulse rounded-full bg-gray-200' />
            <div className='h-[12px] w-[30px] animate-pulse rounded bg-gray-200' />
          </>
        ) : (
          <>
            <img
              alt=''
              className={clsx('size-[16px]', isEmpty && 'opacity-30')}
              src={coinIcon}
            />
            <p
              className={clsx(
                'font-semibold text-[10px] leading-[12px] not-italic',
                isEmpty ? 'text-gray-400' : 'text-black',
              )}
              data-testid={`chart-value-${date}`}
            >
              {value}
            </p>
          </>
        )}
      </div>

      {/* 柱子 */}
      <div
        className={clsx(
          'relative flex h-[194px] w-[34px] items-end justify-center',
          'overflow-hidden rounded-full bg-[#f2f2f5]',
        )}
      >
        {isLoading ? (
          <div
            className='w-[26px] animate-pulse rounded-full bg-gray-200 mb-[4px]'
            style={{
              height: `${Math.random() * 80 + 40}px`,
            }}
          />
        ) : (
          !isEmpty && (
            <div
              className={clsx(
                'w-[26px] rounded-full transition-all duration-500 ease-out',
                'bg-linear-to-t from-[#5c17f2] to-[#a66fff]',
                'shadow-[0_-2px_6px_rgba(92,23,242,0.2)]',
              )}
              style={{
                height:
                  amount && amount > 0
                    ? `${Math.max(barHeight || 0, 26)}px`
                    : '0px',
              }}
            />
          )
        )}
      </div>

      {/* 日期 */}
      {isLoading ? (
        <div className='h-[12px] w-[32px] animate-pulse rounded bg-gray-200' />
      ) : (
        <p
          className={clsx(
            'font-semibold text-[10px] leading-normal not-italic',
            isEmpty ? 'text-gray-400' : 'text-[#5e676d]',
          )}
          data-testid={`chart-date-${date}`}
        >
          {date}
        </p>
      )}
    </div>
  )
}
